import { render, staticRenderFns } from "./addphone.vue?vue&type=template&id=6080c3f6&scoped=true"
import script from "./addphone.vue?vue&type=script&lang=js"
export * from "./addphone.vue?vue&type=script&lang=js"
import style0 from "./addphone.vue?vue&type=style&index=0&id=6080c3f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080c3f6",
  null
  
)

export default component.exports